<template>
  <div
    fluid
    text-center
  >
    <v-alert
      v-model="alerta.mostrar"
      dismissible
      :type="alerta.tipo"
    >
      {{alerta.mensaje}}
    </v-alert>
    <el-listado
      v-if="listado.mostrar"
      v-bind="listado"
      v-bind:permiso="permiso"
      v-bind:modelo-api="modeloApi"
      v-on:editarItem="editar"
      v-on:crearItem="crear"
      v-on:verItem="ver"
      v-on:verPermisos="verPermisos"
      v-on:mostrarError="mostrarError"
    ></el-listado>
    <v-dialog
      v-model="formulario.mostrar"
      persistent
      transition="dialog-bottom-transition"
      scrollable
      max-width="600px"
    >
      <el-formulario
        v-if="formulario.mostrar"
        v-bind="formulario"
        v-bind:permiso="permiso"
        v-bind:modelo-api="modeloApi"
        v-on:alGuardar="alGuardar"
        v-on:alCerrar="alCerrar"
      ></el-formulario>
    </v-dialog>
    <v-dialog
      v-model="permisos.mostrar"
      persistent
      transition="dialog-bottom-transition"
      max-width="840px"
      max-height="400px"
    >
      <usuarios-abm-permisos
        v-if="permisos.mostrar"
        v-bind="permisos"
        v-bind:permiso="permiso"
        v-bind:modelo-api="modeloApi"
        v-on:alGuardar="alGuardarPermisos"
        v-on:alCerrar="alCerrarPermisos"
      ></usuarios-abm-permisos>
    </v-dialog>
  </div>
</template>

<script>
import mixinAbm from '@/mixins/abm'
import ElListado from './UsuariosAbmListado'
import ElFormulario from './UsuariosAbmFormulario'
import UsuariosAbmPermisos from './UsuariosAbmPermisos'
import Modelo from '@/api/usuario'
import _ from 'lodash'

export default {
  mixins: [mixinAbm],
  components: {
    ElListado,
    ElFormulario,
    UsuariosAbmPermisos
  },
  props: {
    componente: {
      type: String,
      default: 'listado'
    },
    soloLectura: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      permiso: 'admin_usuarios',
      modeloApi: Modelo,
      permisos: {
        mostrar: false,
        item: {},
        operacion: null,
        titulo: 'Editar'
      }
    }
  },
  mounted () {
    if (this.componente === 'listado') {
      this.listado.mostrar = true
    } else {
      this.listado.mostrar = false
      if (this.$route.params.id) {
        this.cargarDatos(this.$route.params.id)
      }
    }
  },
  methods: {
    crear () {
      this.formulario = _.assign(this.formulario, {
        operacion: 'alta',
        titulo: 'Crear Usuario',
        item: {
          id: 0,
          usuario: null,
          password: null,
          email: null,
          roles_seleccionados: [],
          instituciones: [],
          persona: {
            id: 0,
            nombre: null,
            apellido: null,
            documento_identidad: {
              tipo_doc_id: null,
              numero: null,
              principal: true
            }
          }
        },
        mostrar: true
      })
    },
    editar (item) {
      this.$router.push({ name: 'usuarios:modificar', params: { id: item.id } })
    },
    ver (item) {
      this.$router.push({ name: 'usuarios:ver', params: { id: item.id } })
    },
    cargarDatos (id) {
      let vm = this
      if (id) {
        this.modeloApi.obtener(id).then(data => {
          data.roles_seleccionados = _.map(data.roles, (rol) => {
            return rol.id
          })
          this.formulario = _.assign(this.formulario, {
            operacion: this.soloLectura ? 'lectura' : 'modif',
            titulo: this.soloLectura ? 'Ver' : 'Editar Usuario',
            item: data,
            mostrar: true
          })
        }, error => {
          vm.mostrarError(error)
        })
      }
    },
    alGuardar (item) {
      if (this.componente === 'listado') {
        this.filtrarListado()
        this.alCerrar()
      } else {
        if (item.id === this.$store.getters.getUser.id) {
          // Es el usuario que esta logeado
          this.$store.dispatch('usuario')
        }
        this.$router.push({ name: 'usuarios' })
      }
    },
    alCerrar () {
      if (this.componente === 'listado') {
        this.formulario.mostrar = false
      } else {
        this.$router.push({ name: 'usuarios' })
      }
    },
    verPermisos (item) {
      let vm = this
      vm.permisos = _.assign(vm.permisos, {
        operacion: 'modif',
        titulo: 'Permisos de usuario',
        item: {
          id: item.id,
          permisos_seleccionados: []
        },
        mostrar: true
      })
    },
    alGuardarPermisos (item) {
      if (item.id === this.$store.getters.getUser.id) {
        // Es el usuario que esta logeado
        this.$store.commit('setPermisos', item)
      }
      this.alCerrarPermisos()
    },
    alCerrarPermisos () {
      this.permisos.mostrar = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
